import React, { useState } from 'react'
import './Home.css'
import SearchIcon from '@material-ui/icons/Search';
import { Link } from 'react-router-dom';
import { useStateValue } from './StateProvider';
import { auth } from './firebase';
import Hotel from './Hotel';

function Header() {
    const [{ basket, user}, dispatch] = useStateValue();
    const [search, setSearch] = useState("");

    const inputEvent = (event) => {
        const data = event.target.value;
        console.log(data);
        setSearch(data);
    }
    const handleAuthentication = () => {
        if (user) {
            auth.signOut();
        }
    }

    return (
        
        <div className='header'>
            <meta name="viewport" content="width=device-width" />
            <div className='links'>
                <Link to="/">
                <div className="home_desktop">
                    <span>Home</span>
                </div>
                </Link>
        
                <Link to={!user && '/login' } >
                <div className="login_desktop" onClick={handleAuthentication} >
                <span>
                    {user ? 'Log Out' : 'Login'}
                </span>
                </div>
                </Link>
                
                <Link to='/showmytable'>
                    <img className="dining__table_desktop" src="/images/dining-table.png" alt="this is an image" />
                </Link>
            </div>

            

            <img className="background_img" src="/images/Background Image.png" alt="this is an image" />
            
            <div className='home__title'>
                <h1>dine-bahar</h1>
            </div>
            
            <div className="home__search" id="search">
                <input className="home__searchInput" 
                    type="text" 
                    size="60" 
                    id="inputbox1" 
                    placeholder="  Search Restaurant Here" 
                    onChange={inputEvent} 
                    value={search}/>
                {/* <SearchIcon className="home__searchIcon" /> */}
            </div>
            
        <div className="hotels">
            <div className='restaurants'>
                <Hotel 
                    image = 'images/Burj Khalifa.png'
                    name = 'XYZ Restaurant'
                    location = 'https://www.google.com/maps/place/Dubai+-+United+Arab+Emirates/@25.0750853,54.947555,10z/data=!3m1!4b1!4m5!3m4!1s0x3e5f43496ad9c645:0xbde66e5084295162!8m2!3d25.2048493!4d55.2707828'
                    bookmytable = '/abc'
                    rates = '⭐⭐⭐⭐⭐'
                />

                <Hotel 
                    image = 'images/Burj Khalifa.png'
                    name = 'XYZ Restaurant'
                    location = 'https://www.google.com/maps/place/Dubai+-+United+Arab+Emirates/@25.0750853,54.947555,10z/data=!3m1!4b1!4m5!3m4!1s0x3e5f43496ad9c645:0xbde66e5084295162!8m2!3d25.2048493!4d55.2707828'
                    bookmytable = '/abc'
                    rates = '⭐⭐⭐⭐⭐'
                />
            </div>
            
            <div className='restaurants'>
                <Hotel 
                    image = 'images/Burj Khalifa.png'
                    name = 'XYZ Restaurant'
                    location = 'https://www.google.com/maps/place/Dubai+-+United+Arab+Emirates/@25.0750853,54.947555,10z/data=!3m1!4b1!4m5!3m4!1s0x3e5f43496ad9c645:0xbde66e5084295162!8m2!3d25.2048493!4d55.2707828'
                    bookmytable = '/abc'
                    rates = '⭐⭐⭐⭐⭐'
                />

                <Hotel 
                    image = 'images/Burj Khalifa.png'
                    name = 'XYZ Restaurant'
                    location = 'https://www.google.com/maps/place/Dubai+-+United+Arab+Emirates/@25.0750853,54.947555,10z/data=!3m1!4b1!4m5!3m4!1s0x3e5f43496ad9c645:0xbde66e5084295162!8m2!3d25.2048493!4d55.2707828'
                    bookmytable = '/abc'
                    rates = '⭐⭐⭐⭐⭐'
                />
            </div>
            
            <div className="footer">
                <h1>dine-bahar</h1>
                <Link to="/careers">
                <div className="carrers">
                    <span className="careers_desktop">Add Restaurant</span>
                </div>
                </Link>
                <h4>Contact us : dinebahar5@gmail.com</h4>
                <h3>Social Links</h3>
                <a href="https://www.facebook.com/"><img className="fb" src="/images/fb.png"/></a>
                <a href="https://www.instagram.com/__mr._prajapati_/"><img className="ig" src="/images/ig.png"/></a>
                <a href="https://twitter.com/AbhiPareshkumar"><img className="twitter" src="/images/twitter.png"/></a>
                
            </div>
            
        </div>  
        </div>
        
        
    )
}

export default Header
